import React from 'react';
import { LoaderView } from 'modules/core/views';

export const withSuspense = (Component: React.ComponentType, FallbackComponent?: React.ComponentType) => () => (
  <React.Suspense fallback={FallbackComponent ?? <LoaderView visible={true} />}>
    <Component />
  </React.Suspense>
);
